// extracted by mini-css-extract-plugin
export default {"container":"GPui","slideInBounce":"yK2J"};